"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInstance = exports.SDKFactory = void 0;
var tslib_1 = require("tslib");
var survicate_1 = require("./instance/survicate");
var SDKFactory = (function () {
    function SDKFactory() {
    }
    SDKFactory.createInstance = function (provider, configuration) {
        switch (provider) {
            case 'survicate':
                return new survicate_1.SurvicateSDK(configuration);
            default:
                console.error('Provider name did not match');
                return null;
        }
    };
    return SDKFactory;
}());
exports.SDKFactory = SDKFactory;
function createInstance(configuration) {
    var provider = configuration.provider, config = tslib_1.__rest(configuration, ["provider"]);
    var client = SDKFactory.createInstance(provider, config);
    return client;
}
exports.createInstance = createInstance;
//# sourceMappingURL=index.js.map